import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

// Get space ID from environment variable
export const getSpaceId = () => {
  const spaceId = import.meta.env.VITE_SPACE_ID || "";
  if (import.meta.env.DEV) {
    console.log("Space ID configured:", spaceId);
  }
  return spaceId;
};

// Create HTTP link with credentials to include cookies
const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_ENDPOINT || "http://localhost:4000/graphql",
  credentials: "include", // Important: This includes HTTP-only cookies
  headers: {
    "x-space-id": getSpaceId(),
  },
});

// Error link to handle GraphQL and network errors
const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }: any) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(
        ({
          message,
          locations,
          path,
        }: {
          message: string;
          locations?: any;
          path?: any;
        }) => {
          console.error(
            `GraphQL error: Message: ${message}, Location: ${locations}, Path: ${path}`
          );
        }
      );
    }

    if (networkError) {
      console.error(`Network error: ${networkError}`);

      // Handle unauthorized errors
      if ("statusCode" in networkError && networkError.statusCode === 401) {
        // Clear any stored user data
        localStorage.removeItem("formsubmits_user");

        // Redirect to login if not already there
        if (!window.location.pathname.includes("/account/signin")) {
          window.location.href = "/account/signin";
        }
      }
    }

    // Forward the operation to continue the chain
    return forward(operation);
  }
);

// Create Apollo Client
export const apolloClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      // Add type policies here if needed for caching
    },
  }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});
